import { UPLOAD_FILES_STATUS } from 'helpers/enum';
import { Reducer } from 'redux';
import { UploadActionTypes } from 'types/actions/upload';

import { uploadConstant } from '../actionTypes';

export interface UploadStats {
  uploading: number;
  uploadSuccess: number;
  uploadFail: number;
  failFiles: File[];
  total: number;
}

interface UploadState {
  files: File[];
  status: UPLOAD_FILES_STATUS;
  taskUploadStatus: UPLOAD_FILES_STATUS;
  stats: UploadStats;
  blobUrl: string;
}

const initialState: UploadState = {
  files: [],
  status: UPLOAD_FILES_STATUS.IDLE,
  taskUploadStatus: UPLOAD_FILES_STATUS.IDLE,
  stats: {
    uploading: 0,
    uploadSuccess: 0,
    uploadFail: 0,
    failFiles: [],
    total: 0,
  },
  blobUrl: '',
};

const uploadReducer: Reducer<UploadState, UploadActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case uploadConstant.UPDATE_UPLOAD_URL: {
      return {
        ...state,
        blobUrl: action.payload,
      };
    }
    case uploadConstant.RESET_UPLOAD: {
      return {
        ...initialState,
      };
    }
    case uploadConstant.UPDATE_UPLOAD_STATUS: {
      return {
        ...state,
        status: action.payload,
      };
    }
    case uploadConstant.UPDATE_FILES: {
      return {
        ...state,
        files: action.payload,
        stats: {
          ...state.stats,
          total: action.payload?.length,
        },
      };
    }
    case uploadConstant.UPDATE_UPLOADING_STATS: {
      return {
        ...state,
        stats: {
          ...state.stats,
          uploading: action.payload,
        },
      };
    }
    case uploadConstant.UPLOAD_SUCCESS: {
      return {
        ...state,
        stats: {
          ...state.stats,
          uploadSuccess: state.stats.uploadSuccess + 1,
          uploading: state.stats.uploading - 1,
        },
      };
    }
    case uploadConstant.UPLOAD_FAIL: {
      return {
        ...state,
        stats: {
          ...state.stats,
          uploadFail: state.stats.uploadFail + 1,
          uploading: state.stats.uploading - 1,
          failFiles: [...state.stats.failFiles, action.payload],
        },
      };
    }

    default:
      return state;
  }
};

export default uploadReducer;
